// import vuex from '../vuex'
import Router from "../router";
import axios from "axios";
import qs from "qs";
import store from "../vuex/index.js";
/* 定时器变量、超时时间 */
var timer,
  overtime = 1000 * 60 * 30;
axios.defaults.baseURL = "/apis/";
if (process.env.NODE_ENV === "development") {
  axios.defaults.baseURL = process.env.devServerUrl + "/apis/";
}
// axios.defaults.baseURL = 'https://testdoctor.smilalign.cn/apis/';
// axios.defaults.baseURL = 'https://doctors.smilalign.cn/apis/';

axios.defaults.transformRequest = function(data) {
  data = qs.stringify(data);
  return data;
};
axios.interceptors.request.use(
  config => {
    // 参数追加token
    if (config.method == "get") {
      config.params == undefined && (config.params = {});
      config.params.token = !config.params.token
        ? localStorage.token
        : config.params.token;
      // if(config.params.token !== false) {
      //     config.params.token = localStorage.token;
      // }else{
      //     delete config.params.token;
      // }
    } else {
      config.data == undefined && (config.data = {});
      config.data.token = !config.data.token
        ? localStorage.token
        : config.data.token;
      // if(config.data.token !== false) {
      //     config.data.token = localStorage.token;
      // }else{
      //     delete config.data.token;
      // }
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  response => {
    let res = response.data;
    if (res.code == "990016" || res.code == "990013") {
      // 中转页
      let list = ["interim", "otherInterim"];
      if (list.includes(Router.currentRoute.name)) {
        return Promise.reject(response.data);
      }
      store.dispatch("clearLoginInfo");
      Router.push({ name: "login", params: { status: 1 } });
      return Promise.reject("");
    } else if (res.code == "E10000") {
      // 请求频繁，不做处理
      return Promise.reject("");
    }
    if (response.data.code) {
      response.data.code = Number(response.data.code);
    }
    return response.data;
  },
  error => {
    return Promise.reject(error);
  }
);
export { axios };



// WEBPACK FOOTER //
// ./src/config/axios.js